import payload_plugin_ALLXFGgbCP from "/home/user/aiboosted-website/node_modules/nuxt-vuefire/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/home/user/aiboosted-website/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/user/aiboosted-website/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/user/aiboosted-website/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import browser_devtools_timing_client_tuAbkkkV0J from "/home/user/aiboosted-website/node_modules/nuxt/dist/app/plugins/browser-devtools-timing.client.js";
import payload_client_yVLowv6hDl from "/home/user/aiboosted-website/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/user/aiboosted-website/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/user/aiboosted-website/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/user/aiboosted-website/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/home/user/aiboosted-website/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/user/aiboosted-website/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_pNVVgm7Ud2 from "/home/user/aiboosted-website/node_modules/nuxt-vuefire/dist/runtime/app/plugin.client.js";
import vuefire_auth_plugin_client_cCwkwh1j5u from "/home/user/aiboosted-website/.nuxt/vuefire-auth-plugin.client.mjs";
import vuefire_plugin_8cq4FnzXKb from "/home/user/aiboosted-website/.nuxt/vuefire-plugin.mjs";
import plugin_client_7d3Ap34qR4 from "/home/user/aiboosted-website/node_modules/nuxt-vuefire/dist/runtime/app-check/plugin.client.js";
import voiceflow_client_y70Z2rWGVR from "/home/user/aiboosted-website/plugins/voiceflow.client.js";
export default [
  payload_plugin_ALLXFGgbCP,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  browser_devtools_timing_client_tuAbkkkV0J,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_pNVVgm7Ud2,
  vuefire_auth_plugin_client_cCwkwh1j5u,
  vuefire_plugin_8cq4FnzXKb,
  plugin_client_7d3Ap34qR4,
  voiceflow_client_y70Z2rWGVR
]